export default "__VITE_ASSET__d56ddb2c__"